import { render, staticRenderFns } from "./AssignRevokeModal.vue?vue&type=template&id=53aeba9c&scoped=true"
import script from "./AssignRevokeModal.vue?vue&type=script&lang=js"
export * from "./AssignRevokeModal.vue?vue&type=script&lang=js"
import style0 from "./AssignRevokeModal.vue?vue&type=style&index=0&id=53aeba9c&prod&lang=scss&scoped=true"
import style1 from "./AssignRevokeModal.vue?vue&type=style&index=1&id=53aeba9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53aeba9c",
  null
  
)

export default component.exports